import { CSSObject } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'alpha.500',
  mb: '1',
};

export const FooterMoreOpenText: CSSObject = {
  color: 'alpha.500',
  fontSize: 'xs',
};

export const BoxMoreText: CSSObject = {
  w: '8',
  color: 'alpha.500',
};

export const FooterBodyText: CSSObject = {
  color: 'blackAlpha.500',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'alpha.600',
  mb: '2',
  '&.raceNumber': {
    fontWeight: 'bold',
    borderBottom: '1px dashed',
    borderColor: 'rgba(0, 0, 0, 0.16)',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};